import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import Seo from "./Seo";
import BookingCalendar from "./BookingCalendar";
import { Reveal } from "./Reveal";
import { BOOKING_SERVICES } from "../lib/site";

export default function BookingCalendarRedirect() {
  const { pathname } = useLocation();

  const requestedService = useMemo(() => {
    const slug = pathname.replace(/^\/booking-calendar\//, "").replace(/\/+$/, "");
    return BOOKING_SERVICES.find((s) => s.url.endsWith(`/${slug}`))?.name ?? null;
  }, [pathname]);

  return (
    <>
      <Seo
        title="Book a Consultation | Directive Optive Solutions"
        description="Book a consultation online — Monday to Friday, 9 AM to 5 PM Mountain Time. Call (801) 474-5890 or email info@directiveoptivesolutions.com."
        path={pathname}
        noindex
      />
      <section className="bg-sage/85 pb-20 pt-36 sm:pt-44" data-testid="booking-redirect-section">
        <div className="container-shell">
          <Reveal>
            <p className="eyebrow">Booking</p>
            <h1 className="mt-4 max-w-2xl font-serif text-4xl leading-tight text-olive sm:text-5xl">Book your consultation.</h1>
            {requestedService && (
              <p className="mt-5 text-base text-moss" data-testid="booking-requested-service">
                You asked to book: <span className="font-bold text-olive">{requestedService}</span> — it’s selected below. Pick a day and time that suit you.
              </p>
            )}
          </Reveal>
          <Reveal delay={0.1} className="mt-10 min-w-0">
            <BookingCalendar preselectService={requestedService || ""} dataTestId="booking-calendar-redirect" />
          </Reveal>
        </div>
      </section>
    </>
  );
}
